
export function canPerformActionOnDay(permObj, prefix) {
  // Debug logging for day-based permission check
  console.log('Day Permission Check:', {
    prefix,
    permObj,
    currentDay: new Date().getDay(),
    dayName: ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"][new Date().getDay()]
  });
  
  if (!permObj) return false;

  const dayIdx = new Date().getDay();
  const days = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
  const currentDay = days[dayIdx];


   if(permObj[`${prefix}_all_days`]==='Y'){
    return true;
   }
  // Enhanced debug logging
  const specificDayPermission = permObj[`${prefix}_${currentDay}`];
  const allDaysPermission = permObj[`${prefix}_all_days`];
  
  console.log('Permission Details:', {
    specificDayPermission,
    allDaysPermission,
    currentDay,
    prefix,
    permissionKey: `${prefix}_${currentDay}`,
    allDaysKey: `${prefix}_all_days`
  });

  // Check all_days permission first
  if (allDaysPermission === 'Y') {
    console.log(`Access granted: ${prefix}_all_days is Y`);
    return true;
  }

  // If all_days is not Y, check specific day permission
  if (specificDayPermission === 'Y') {
    console.log(`Access granted: ${prefix}_${currentDay} is explicitly set to Y`);
    return true;
  }

  console.log(`Access denied: No permission for ${prefix} on ${currentDay}`);
  return false;
}


export function getDayPermissionMessage(permObj, prefix) {
  if (!permObj) {
    return "No permissions configured";
  }

  const dayIdx = new Date().getDay();
  const days = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
  const currentDay = days[dayIdx];
  const actionMap = {
    'a': 'add',
    'm': 'modify',
    'd': 'delete',
    'q': 'view'
  };

  const allDaysPermission = permObj[`${prefix}_all_days`];
  const specificDayPermission = permObj[`${prefix}_${currentDay}`];

  if (allDaysPermission === "Y") {
    return "";
  }

  if (specificDayPermission === "Y") {
    return "";
  }

  return `You don't have permission to ${actionMap[prefix]} items on ${currentDay}`;
}


export const getFormPermissions = (formName, employeeData) => {
  const roleCd = employeeData.permission.user[0].role_cd;
  console.log(roleCd,"rorrrrrrrrrrrrlllllecodeeeeeeeeee");
   console.log("Employee data is this ", employeeData)
   console.log("check ---------------1------------");
  if (roleCd == "1") {
    return {
      canAdd: true,
      canModify: true,
      canDelete: true,
      canQuery: true,
      messages: {
        add: "",
        modify: "",
        delete: "",
        query: "",
      },
    };
  }
  console.log("check ---------------2------------");
  if (!employeeData?.permission?.permission || !Array.isArray(employeeData.permission.permission)) {
    return {
      canAdd: false,
      canModify: false,
      canDelete: false,
      canQuery: false,
      messages: {
        add: "No permissions configured",
        modify: "No permissions configured",
        delete: "No permissions configured",
        query: "No permissions configured",
      },
    };
  }
  console.log("check ---------------3------------");
  const days = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
  const dayIdx = new Date().getDay();

  const formPermission = employeeData.permission.permission.find(
    (p) => p.form_name.trim() === formName
  );
  console.log("check ---------------4------------");
  if (!formPermission) {
    return {
      canAdd: false,
      canModify: false,
      canDelete: false,
      canQuery: false,
      messages: {
        add: "No form permissions found",
        modify: "No form permissions found",
        delete: "No form permissions found",
        query: "No form permissions found",
      },
    };
  }

  const canAdd = formPermission.l_add === "Y" && canPerformActionOnDay(formPermission, "a");
  const canModify = formPermission.l_modify === "Y" && canPerformActionOnDay(formPermission, "m");
  const canDelete = formPermission.l_delete === "Y" && canPerformActionOnDay(formPermission, "d");
  const canQuery = formPermission.l_query === "Y" && canPerformActionOnDay(formPermission, "q");
  console.log("check ---------------5------------");
  return {
    canAdd,
    canModify,
    canDelete,
    canQuery,
    messages: {
      add: formPermission.l_add !== "Y" ? "You don't have permission to add items" : getDayPermissionMessage(formPermission, "a"),
      modify: formPermission.l_modify !== "Y" ? "You don't have permission to modify items" : getDayPermissionMessage(formPermission, "m"),
      delete: formPermission.l_delete !== "Y" ? "You don't have permission to delete items" : getDayPermissionMessage(formPermission, "d"),
      query: formPermission.l_query !== "Y" ? "You don't have permission to view items" : getDayPermissionMessage(formPermission, "q"),
    },
  };
};